export const supportTicketsPaths = {
    emailChange: `support-tickets/email-change`,
    emailChangeCancel: `support-tickets/email-change/:ticketId`,
} as const;
